import { render, staticRenderFns } from "./screenList.vue?vue&type=template&id=2e537466&scoped=true"
import script from "./screenList.vue?vue&type=script&lang=js"
export * from "./screenList.vue?vue&type=script&lang=js"
import style0 from "./screenList.vue?vue&type=style&index=0&id=2e537466&prod&lang=less&scoped=true"
import style1 from "./screenList.vue?vue&type=style&index=1&id=2e537466&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e537466",
  null
  
)

export default component.exports